var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { fileIcons } from '@/support/Icon';
import { formatDate } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialogMedia from './CreateDialog/CreateDialogMedia';
import { Media as MediaModel, MediaIncludes } from '@/models/Media';
let Media = class Media extends Vue {
    constructor() {
        super(...arguments);
        // #region @Refs
        // #endregion
        // #region Class properties
        this.emptyResult = false;
        this.isUploadingFile = false;
        this.selectedFile = null;
        this.selectedScoolfolioItem = [];
        this.userFiles = [];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    initialize() {
        this.emptyResult = false;
        new MediaModel()
            .include([MediaIncludes.LINKS, MediaIncludes.TARGET])
            .filter({ ...this.mediaFilters })
            .all()
            .then((userFiles) => {
            if (!userFiles.length) {
                this.emptyResult = true;
            }
            this.userFiles = userFiles;
        });
    }
    // #endregion
    // #region Class methods
    getFileIcon(mimeType) {
        if (fileIcons[mimeType]) {
            return fileIcons[mimeType];
        }
        else {
            return fileIcons.other;
        }
    }
    deleteUserFile(file) {
        this.selectedFile = file;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    parseDate(date) {
        return formatDate(date);
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get dialogOptions() {
        const file = this.selectedFile;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('portfolio.document') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!file) {
                            return;
                        }
                        file
                            .delete()
                            .then(() => {
                            this.initialize();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedFile = null;
                    },
                },
            },
        };
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], Media.prototype, "mediaFilters", void 0);
Media = __decorate([
    Component({
        components: {
            CreateDialogMedia,
        },
    })
], Media);
export default Media;
